import { Base } from "./base";
import { Category } from '../Interfaces';

export class Money extends Base {
    type: string;
    type_translation: string;

    concept: string;
    amount: number;
    date: string;
    dateValue: Date;
    constructor(json?: Object,
        public category?: Category,
        public type_data?: any
    ) {
        super(json);
        this.dateValue = new Date(this.date);
    }
    getDateLocaleString(): string {
        // let day: string = `${this.dateValue.getDate()}`.padStart(2, '0');
        // let month: string = `${this.dateValue.getMonth() + 1}`.padStart(2, '0');
        // let year: string = `${this.dateValue.getFullYear()}`;
        // // let options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        // // return this.dateValue.toLocaleDateString('es-ES', options); // ex: mar., 24/7/2018
        // return `${year}-${month}-${day}`;
        return this.date;
    }
    dateIsActualMonthNYear(): boolean {
        let now = new Date();
        return this.dateValue.getMonth() == now.getMonth()
            && this.dateValue.getFullYear() == now.getFullYear();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/money.ts